// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__5CGWd","layout-body":"style_layout-body__cwIof"};